'use strict';

export default class TerminalId {
	constructor(params) {
		this.root = document.querySelector(params.root);
	}

	init() {
		if (!this.root) return false;

		this.id = localStorage.getItem('terminal-id') || $.cookie('terminal-id');

		if (this.root.tagName === 'INPUT' && this.id) {
			this.root.value = this.id;
			return;
		}

		this._matchHTML();
		this._containersHandler();
		this._changeBtnHandler();
		this._inputHandler();
		this._formHandler();
		this._valueInsert();
	}

	_matchHTML() {
		this.form = this.root.querySelector('form');
		this.input = this.root.querySelector('[data-terminal-id-field]');
		this.valueContainers = [...this.root.querySelectorAll('[data-terminal-id-value]')];
		this.formContainer = this.root.querySelector('[data-terminal-id-form ]');
		this.viewContainer = this.root.querySelector('[data-terminal-id-view ]');
		this.changeBtn = this.root.querySelector('[data-terminal-id-change-btn]')

	}

	_containersHandler() {
		if (!this.formContainer || !this.viewContainer) return false;

		if (this.id) {
			this.formContainer.style.display = 'none';
			this.viewContainer.style.display = '';
		} else {
			this.formContainer.style.display = '';
			this.viewContainer.style.display = 'none';
		}
	}

	_changeBtnHandler() {
		if (!this.changeBtn) return false;

		this.changeBtn.addEventListener('click', e => {
			e.preventDefault();

			this.formContainer.style.display = '';
			this.viewContainer.style.display = 'none';
		})
	}

	_inputHandler() {
		if (!this.input || !this.id) return false;

		this.input.value = this.id;
	}

	_formHandler() {
		if (!this.form || !this.input) return false;

		this.validator = $(this.form).validate({
			submitHandler: form => {
				this.id = this.input.value;

				localStorage.setItem('terminal-id', this.id );
				$.cookie('terminal-id', this.id , { expires: 365 * 10, path: '/' });

				this._valueInsert();

				this.formContainer.style.display = 'none';
				this.viewContainer.style.display = '';
			}
		});
	}

	_valueInsert() {
		if (!this.valueContainers.length || !this.id) return false;

		this.valueContainers.forEach(container => {
			container.innerHTML = this.id;
		})
	}
}
